"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _excluded = ["hasShadow", "size"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var BellIcon = function BellIcon(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.65 1.008A.859.859 0 1 1 8.96.709a.859.859 0 0 1 1.69.299zM9.54 2.31c-2.768-.315-4.504 1.046-5.207 4.083C3.631 9.429 2.39 11.142.611 11.53c-.72.466-.804.938-.25 1.417.83.719 3.471 1.852 6.87 2.451l.061.011.01.002c3.4.6 6.269.438 7.295.047.684-.261.767-.733.25-1.418-1.539-.974-2.12-3.008-1.741-6.102.378-3.093-.787-4.966-3.495-5.617l-.072-.012zM4.602 15.678a3.044 3.044 0 0 0-.206.709 2.576 2.576 0 0 0 5.072.894c.043-.242.051-.541.027-.774 0 0-1.18-.078-2.452-.303-1.273-.224-2.441-.526-2.441-.526z",
    fill: "#fff"
  }));
};
BellIcon.defaultProps = {
  viewBox: "0 0 16 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var PricewatchSubscribeBellIcon = function PricewatchSubscribeBellIcon(_ref) {
  var hasShadow = _ref.hasShadow,
    size = _ref.size,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(Shadow, (0, _extends2["default"])({
    size: size,
    hasShadow: hasShadow
  }, props), /*#__PURE__*/_react["default"].createElement(IconWithGradient, {
    size: size
  }));
};
var Shadow = _styledComponents["default"].span.withConfig({
  displayName: "PricewatchSubscribeBellIcon__Shadow",
  componentId: "sc-tb9mgp-0"
})(["pointer-events:all;position:relative;display:inline-block;", " &:after{", " background:linear-gradient(360deg,#0ACEBF 0%,#B65EBA 100%);mix-blend-mode:normal;filter:blur(12px);position:absolute;top:0;right:0;left:0;bottom:0;width:100%;height:calc(100% - 10px);}"], function (_ref2) {
  var size = _ref2.size;
  return (0, _styledComponents.css)(["width:", "px;height:", "px;"], size, size);
}, function (_ref3) {
  var hasShadow = _ref3.hasShadow;
  return hasShadow && (0, _styledComponents.css)(["content:\"\";"]);
});
var IconWithGradient = (0, _styledComponents["default"])(BellIcon).withConfig({
  displayName: "PricewatchSubscribeBellIcon__IconWithGradient",
  componentId: "sc-tb9mgp-1"
})(["border-radius:50%;position:relative;z-index:1;padding:6px;background:linear-gradient(360deg,#0BDBCB 0%,#CB47D1 100%);", ""], function (_ref4) {
  var size = _ref4.size;
  return (0, _styledComponents.css)(["width:", "px;height:", "px;"], size, size);
});
PricewatchSubscribeBellIcon.propTypes = {
  hasShadow: _propTypes["default"].bool,
  size: _propTypes["default"].number
};
PricewatchSubscribeBellIcon.defaultProps = {
  hasShadow: false,
  size: 32
};
var _default = exports["default"] = PricewatchSubscribeBellIcon;